import { type RxCollection, type RxCollectionCreator } from 'rxdb';
import { AppointmentProposalOptionSOW } from '../../../data-access/appointmentProposalOptionSows';
import {
  identityMigration,
  lwwConflictHandler,
} from '../../rxdb/utils/collectionDefaults';

const sowsSchema = {
  version: 2,
  primaryKey: 'appointmentProposalOptionSOWId',
  type: 'object',
  properties: {
    appointmentProposalOptionSOWId: { type: 'string', maxLength: 36 },
    appointmentProposalOptionId: { type: 'string', maxLength: 36 },
    appointmentProposalId: { type: 'string', maxLength: 36 },
    appointmentId: { type: 'string', maxLength: 36 },
    jobId: { type: 'string' },
    entityType: { type: 'string' },
    sowId: { type: 'string' },
    title: { type: 'string' },
    summary: { type: 'string' },
    shortDescription: { type: 'string' },
    status: { type: 'string' },
    sortOrder: { type: 'number' },
    syncedAt: {
      type: 'number',
      multipleOf: 1,
      maximum: 9999999999999,
      minimum: 0,
    },
    updatedAt: { type: 'string' },
    createdAt: { type: 'string' },
    offlineSyncErrors: { type: ['object', 'null'] },
  },
  indexes: [
    ['appointmentProposalOptionId'],
    ['appointmentProposalId'],
    ['syncedAt'],
  ],
  required: [
    'appointmentProposalOptionSOWId',
    'appointmentProposalOptionId',
    'appointmentProposalId',
    'syncedAt',
  ],
} as const;

export const sowsCollections: Record<
  'appointment_proposal_option_sows',
  RxCollectionCreator
> = {
  appointment_proposal_option_sows: {
    autoMigrate: false,
    schema: sowsSchema,
    conflictHandler: lwwConflictHandler,
    migrationStrategies: {
      1: identityMigration,
      2: identityMigration,
    },
  },
};

export type AppointmentProposalOptionSOWDocType =
  AppointmentProposalOptionSOW & {
    syncedAt: number;
  };

export type AppointmentProposalOptionSOWsCollections = {
  appointment_proposal_option_sows: RxCollection<AppointmentProposalOptionSOWDocType>;
};
